import React, { MouseEventHandler, ReactNode } from 'react';
import { LinkType, StyledLink, StyledAnchor } from './styles';

interface LinkProps {
    href?: string;
    type?: keyof typeof LinkType;
    isExternal?: boolean;
    children: string | ReactNode;
    openInNewWindow?: boolean;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
    className?: string;
}

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
    (
        {
            href,
            type = 'default',
            isExternal = false,
            children,
            openInNewWindow,
            onClick,
            className,
        }: LinkProps,
        ref
    ) => {
        const isUrlEmptyOrUndefined = !href || href.trim() === '';

        let target: string | undefined;
        if (openInNewWindow) {
            target = '_blank';
        } else {
            target = undefined;
        }

        const rel = openInNewWindow ? 'noopener noreferrer' : undefined;

        if (isExternal) {
            return (
                <StyledAnchor
                    href={isUrlEmptyOrUndefined ? '#' : href}
                    type={type}
                    target={target}
                    rel={rel}
                    ref={ref}
                    onClick={e => {
                        if (isUrlEmptyOrUndefined) {
                            e.preventDefault();
                        }
                        onClick?.(e);
                    }}
                    className={className}
                >
                    {children}
                </StyledAnchor>
            );
        }

        return (
            <StyledLink
                href={isUrlEmptyOrUndefined ? '#' : href}
                type={type}
                target={target}
                rel={rel}
                ref={ref}
                onClick={e => {
                    if (isUrlEmptyOrUndefined) {
                        e.preventDefault();
                    }
                    onClick?.(e);
                }}
                className={className}
            >
                {children}
            </StyledLink>
        );
    }
);

Link.displayName = 'Link';

export default Link;
